import React from 'react';
import PropTypes from 'prop-types';
import Text from '../../Text';
import { dataHooks } from '../constants';
import { classes } from '../Notification.st.css';
import { EllipsisCommonProps } from '../../common/PropTypes/EllipsisCommon';

const TextLabel = ({
  ellipsis = true,
  placement = 'bottom',
  children,
  ...propsWithNoDefaults
}) => (
  <div className={classes.label}>
    <Text
      weight="normal"
      {...{
        ellipsis,
        placement,
        ...propsWithNoDefaults,
      }}
      light
      dataHook={dataHooks.notificationLabel}
    >
      {children}
    </Text>
  </div>
);

TextLabel.propTypes = {
  children: PropTypes.node,
  ...EllipsisCommonProps,
};

TextLabel.displayName = 'Notification.TextLabel';

export default TextLabel;
